import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { SurveysService } from '../../services/surveys';
import { analyticsProvider } from '../analytics';
import { surveyProvider } from '../survey';
import { EvaluateSurveyEffects } from './evaluate-survey.effects';
import { evaluateSurveyFeature } from './evaluate-survey.reducer';
import { EvaluateSurveyResources } from './evaluate-survey.resources';

export function evaluateSurveyProvider() {
  return [
    provideState(evaluateSurveyFeature),
    provideEffects(EvaluateSurveyEffects),
    surveyProvider(),
    analyticsProvider(),
    EvaluateSurveyResources,
    SurveysService,
  ];
}
